import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { WalletValue, walletAmount } from '../context/AuthContext';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, History, Activity, Bot, X, Users, Coins, Eye, Swords, Play, ChevronLeft, ChevronRight } from 'lucide-react';
import { toast } from 'sonner';
import { useChatLayout } from '../context/ChatLayoutContext';
import { useAuth } from '../context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const WS_URL = BACKEND_URL.replace(/^http/, 'ws');

// --- K, M, B FORMATLAYICILARI ---
const parseAmount = (valStr) => {
  if (!valStr) return 0;
  // ⚠️ BİNLİK AYIRICI TEMİZLENMELİ. formatAmount() büyük sayıları
  // toLocaleString ile üretiyor ("1,457,545"); parseFloat virgülde durup
  // 1 döndürüyordu. MAX butonuna basan kullanıcı 1 birim bahis oynuyordu.
  let str = valStr.toString().trim().toLowerCase().replace(/[,\s]/g, '');
  let multiplier = 1;
  if (str.endsWith('k')) { multiplier = 1000; str = str.slice(0, -1); }
  else if (str.endsWith('m')) { multiplier = 1000000; str = str.slice(0, -1); }
  else if (str.endsWith('b')) { multiplier = 1000000000; str = str.slice(0, -1); }
  
  const parsedValue = parseFloat(str);
  return isNaN(parsedValue) ? 0 : Math.floor(parsedValue * multiplier);
};

const formatAmount = (amount) => {
  if (amount === undefined || amount === null || amount === 0) return '';
  if (amount >= 1000000) return amount.toLocaleString();
  if (amount >= 1000) return parseFloat((amount / 1000).toFixed(2)) + 'K';
  return amount.toString();
};

const formatCompact = (number) => {
  if (!number) return "0";
  return new Intl.NumberFormat('en-US', { notation: "compact", maximumFractionDigits: 2 }).format(number);
};

// --- GERÇEKÇİ 3D CASINO ÇİPİ ---
const Coin3D = ({ isFlipping, resultSide, size = 'w-24 h-24 md:w-32 md:h-32 lg:w-44 lg:h-44' }) => {
  const rotation = isFlipping 
    ? 3600 + (resultSide === 'tails' ? 180 : 0) 
    : (resultSide === 'tails' ? 180 : 0);

  return (
    <div className="flex flex-col items-center">
      <div className={`relative ${size} z-10`} style={{ perspective: '1200px' }}>
        <motion.div
          className="w-full h-full relative rounded-full shadow-[0_15px_35px_rgba(0,0,0,0.6)]"
          style={{ transformStyle: 'preserve-3d' }}
          animate={{ rotateY: rotation, y: isFlipping ? -140 : 0, scale: isFlipping ? 1.15 : 1 }}
          transition={{ duration: isFlipping ? 5 : 0.5, ease: isFlipping ? [0.2, 0.8, 0.3, 1] : "easeInOut" }}
        >
          <div className="absolute inset-0 rounded-full bg-yellow-900" style={{ transform: 'translateZ(-2px)' }} />
          <div className="absolute inset-0 rounded-full bg-slate-800" style={{ transform: 'translateZ(2px)' }} />

          {/* HEADS */}
          <div className="absolute w-full h-full rounded-full flex items-center justify-center p-1 bg-gradient-to-br from-yellow-300 via-yellow-500 to-yellow-700" style={{ backfaceVisibility: 'hidden', transform: 'translateZ(3px)' }}>
            <div className="w-full h-full rounded-full border-[3px] border-yellow-200/60 bg-gradient-to-br from-yellow-400 via-yellow-600 to-yellow-800 shadow-[inset_0_0_20px_rgba(0,0,0,0.6)] relative overflow-hidden flex items-center justify-center">
              <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-tr from-transparent via-white/40 to-transparent transform -rotate-45 pointer-events-none" />
              <div className="w-[82%] h-[82%] rounded-full border-2 border-yellow-700/50 bg-gradient-to-b from-yellow-500 to-yellow-600 flex items-center justify-center shadow-[inset_0_5px_15px_rgba(0,0,0,0.4)] relative z-10">
                <span className="font-black text-yellow-100 text-5xl md:text-6xl lg:text-7xl drop-shadow-[0_3px_3px_rgba(0,0,0,0.6)] tracking-tighter" style={{ fontFamily: 'Georgia, serif' }}>H</span>
              </div>
            </div>
          </div>
          
          {/* TAILS */}
          <div className="absolute w-full h-full rounded-full flex items-center justify-center p-1 bg-gradient-to-br from-slate-200 via-slate-400 to-slate-600" style={{ backfaceVisibility: 'hidden', transform: 'rotateY(180deg) translateZ(3px)' }}>
            <div className="w-full h-full rounded-full border-[3px] border-slate-100/60 bg-gradient-to-br from-slate-300 via-slate-500 to-slate-700 shadow-[inset_0_0_20px_rgba(0,0,0,0.6)] relative overflow-hidden flex items-center justify-center">
               <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-tr from-transparent via-white/50 to-transparent transform -rotate-45 pointer-events-none" />
              <div className="w-[82%] h-[82%] rounded-full border-2 border-slate-600/50 bg-gradient-to-b from-slate-400 to-slate-500 flex items-center justify-center shadow-[inset_0_5px_15px_rgba(0,0,0,0.4)] relative z-10">
                <span className="font-black text-slate-100 text-5xl md:text-6xl lg:text-7xl drop-shadow-[0_3px_3px_rgba(0,0,0,0.6)] tracking-tighter" style={{ fontFamily: 'Georgia, serif' }}>T</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      <motion.div 
        className="w-24 md:w-32 lg:w-40 h-4 md:h-6 bg-black/80 rounded-[100%] blur-xl mt-4 md:mt-6 z-0"
        animate={{ scale: isFlipping ? 0.3 : 1, opacity: isFlipping ? 0.1 : 0.7 }}
        transition={{ duration: isFlipping ? 5 : 0.5, ease: isFlipping ? [0.2, 0.8, 0.3, 1] : "easeInOut" }}
      />
    </div>
  );
};

// --- ANA BİLEŞEN ---
export const Coinflip = () => {
  const [activeGames, setActiveGames] = useState([]);
  // 💬 Aç/kapa durumu paylaşımlı: sayfa değişse de korunur.
  const { chatOpen } = useChatLayout();
  const [finishedGames, setFinishedGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all'); 
  
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [createBet, setCreateBet] = useState(''); 
  const [createSide, setCreateSide] = useState('heads');
  
  const [selectedGame, setSelectedGame] = useState(null);
  const [modalState, setModalState] = useState('waiting');
  const [countdown, setCountdown] = useState(2);
  
  const replayTimers = useRef([]);
  const wsRef = useRef(null);

  const { user: currentUser, betToRaw, rawToBet, betLimits, fmtMoney, balance, wallet } = useAuth();
  const token = localStorage.getItem('token') || 'guest';

  // GERİ SAYIM MOTORU
  useEffect(() => {
    let timer;
    if (modalState === 'starting' && countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [modalState, countdown]);


  useEffect(() => {
    const fetchGames = async (isInitialLoad = false) => {
      try {
        // Aktif oyunları her zaman güncelle
        const resActive = await axios.get(`${BACKEND_URL}/api/game/coinflip/active`);
        setActiveGames(resActive.data.games || []);
        
        // Geçmiş oyunları SADECE sayfa ilk yüklendiğinde çek
        if (isInitialLoad) {
          const resLive = await axios.get(`${BACKEND_URL}/api/game/live`);
          
          const allCoinflips = resLive.data.filter(g => g.game_type === 'coinflip');
          const uniqueHistory = [];
          const seenGameIds = new Set();
          
          allCoinflips.forEach(h => {
            if (h.details && h.details.game_id && !seenGameIds.has(h.details.game_id)) {
              seenGameIds.add(h.details.game_id);
              uniqueHistory.push(h);
            }
          });
          
          const cfHistory = uniqueHistory.slice(0, 10);
          
          const formattedHistory = cfHistory.map(h => {
            const isCreatorRecord = h.details.creator_id ? (h.user_id === h.details.creator_id) : true;
            const actualCreatorSide = isCreatorRecord 
                ? h.details.picked_side 
                : (h.details.picked_side === 'heads' ? 'tails' : 'heads');

            let finalWinnerId;
            if (h.win_amount > 0) {
                finalWinnerId = h.user_id; 
            } else {
                finalWinnerId = isCreatorRecord ? h.details.joiner_id : h.details.creator_id;
            }

            return {
              id: h.details.game_id,
              bet: h.bet_amount,
              status: 'finished',
              creator_id: h.details.creator_id || h.user_id,
              creator_username: h.details.creator_username || h.username,
              creator_side: actualCreatorSide,
              joiner_is_bot: h.details.vs_bot,
              joiner_id: h.details.joiner_id || (h.details.vs_bot ? 'bot' : 'opponent'),
              joiner_username: h.details.joiner_username || (h.details.vs_bot ? 'Bot' : 'Opponent'),
              winning_side: h.details.winning_side,
              winner_id: finalWinnerId,
              // 🔒 Maçın mühürlü cüzdanı — geçmiş satırı kendi biriminde
              // gösterilir. Düşerse D6 ile "main" sayılır ve BB maçları
              // Robux gibi, tutarları 1000 kat şişik görünür.
              wallet: h.wallet || h.details?.wallet
            };
          });
          
          setFinishedGames(formattedHistory);
        }
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        if (isInitialLoad) setLoading(false);
      }
    };

    // İlk yüklemede history'yi de çekmesi için 'true' gönderiyoruz
    fetchGames(true);

    // Her 5 saniyede bir sadece aktif oyunları günceller, geçmişi KORUR
    const pollInterval = setInterval(() => fetchGames(false), 5000);

    // 🍀 Lobi listesi AKTİF CÜZDANA göre filtreli gelir (backend D4 ile
    // farklı cüzdandan katılımı zaten reddediyor). Cüzdan değişince ANINDA
    // tazele; yoksa diğer cüzdanın lobileri 5 saniye ekranda kalır ve
    // tıklayan kullanıcı sebebini anlamadan 409 alır.
    const onWalletChange = () => {
      // ⚠️ Açık oyun modalı listenin bir KOPYASINI tutuyor; cüzdan
      // değişince tutarlar eski birimde kalırdı. Modal kapatılır —
      // lobi zaten farklı cüzdanda olabilir ve katılım reddedilir.
      setSelectedGame(null);
      fetchGames(false);
    };
    window.addEventListener('wallet:changed', onWalletChange);

    const websocket = new WebSocket(`${WS_URL}/ws/coinflip/${token}`);
    wsRef.current = websocket;
    
    websocket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      
      if (data.type === 'COINFLIP_LIST') {
        setActiveGames(data.games);
      }
      else if (data.type === 'COINFLIP_CREATED') {
        setActiveGames(prev => [data.game, ...prev]);
      }
      else if (data.type === 'COINFLIP_STARTING') {
        setActiveGames(prev => prev.map(g => g.id === data.game_id ? { ...g, status: 'starting', joiner_id: data.game.joiner_id, joiner_username: data.game.joiner_username, joiner_is_bot: data.game.joiner_is_bot } : g));
        setSelectedGame(prev => {
          if (prev && prev.id === data.game_id) {
            setModalState('starting');
            setCountdown(data.countdown);
            return { ...prev, joiner_id: data.game.joiner_id, joiner_username: data.game.joiner_username, joiner_is_bot: data.game.joiner_is_bot };
          }
          return prev;
        });
      }
      else if (data.type === 'COINFLIP_FLIPPING') {
        setActiveGames(prev => prev.map(g => g.id === data.game_id ? { ...g, status: 'flipping', winning_side: data.winning_side } : g));
        setSelectedGame(prev => {
          if (prev && prev.id === data.game_id) {
            setModalState('flipping');
            return { ...prev, winning_side: data.winning_side };
          }
          return prev;
        });
      }
      else if (data.type === 'COINFLIP_RESULT') {
        // 🌟 1. ADIM: Aktif Oyunlar (Lobi) kartında kazananı vurgula ve Finished yaz
        setActiveGames(prev => prev.map(g => 
          g.id === data.game_id 
            ? { ...g, status: 'finished', winner_id: data.winner_id, winning_side: data.winning_side } 
            : g
        ));

        // Eğer modal açıksa onu da bitir
        setSelectedGame(prev => {
          if (prev && prev.id === data.game_id) {
            setModalState('finished');
            return { ...prev, winner_id: data.winner_id, winning_side: data.winning_side ?? prev.winning_side, status: 'finished' };
          }
          return prev;
        });

        // 🌟 2. ADIM: 3 Saniyelik Şov Süresi bittikten sonra anında yukarıdan sil, aşağıya ekle
        setTimeout(() => {
          setActiveGames(currentActive => {
            const gameToMove = currentActive.find(g => g.id === data.game_id);
            
            if (gameToMove) {
              setFinishedGames(oldHistory => {
                if (oldHistory.some(h => h.id === data.game_id)) return oldHistory;
                
                const newHistoryItem = {
                  id: gameToMove.id,
                  bet: gameToMove.bet,
                  // 🔒 Mühür taşınmalı (bkz. yukarıdaki not).
                  wallet: gameToMove.wallet,
                  status: 'finished',
                  creator_id: gameToMove.creator_id,
                  creator_username: gameToMove.creator_username,
                  creator_side: gameToMove.creator_side,
                  joiner_is_bot: gameToMove.joiner_is_bot,
                  joiner_id: gameToMove.joiner_id,
                  joiner_username: gameToMove.joiner_username,
                  winning_side: data.winning_side,
                  winner_id: data.winner_id
                };
                
                return [newHistoryItem, ...oldHistory].slice(0, 10);
              });
            }
            
            // Aktif oyunlardan O AN siliniyor
            return currentActive.filter(g => g.id !== data.game_id);
          });
          
          // Her şey bittikten sonra yedek olarak backend'i tazele
          setTimeout(() => fetchGames(false), 1000);
        }, 3000); // 3 saniye bekle
      }
    };

    return () => {
      clearInterval(pollInterval);
      window.removeEventListener('wallet:changed', onWalletChange);
      websocket.close();
      clearReplayTimers();
    };
  }, [token]);

  const clearReplayTimers = () => {
    replayTimers.current.forEach(clearTimeout);
    replayTimers.current = [];
  };

  const handleBetChange = (val) => setCreateBet(val);
  const addBetAmount = (val) => {
    const current = parseAmount(createBet);
    setCreateBet(String(current + val));
  };
  const multiplyBet = (mult) => {
    const current = parseAmount(createBet);
    setCreateBet(String(Math.floor(current * mult)));
  };

  const handleCreateSubmit = async () => {
    // 🎯 Kullanıcı AKTİF CÜZDANIN biriminde yazar; betToRaw saklama
    // birimine çevirir (BB'de ×1000). Bu satır olmadan "10" yazan oyuncu
    // 10 mili-BB (0,01 BB) ile lobi açardı.
    const parsedBet = betToRaw(parseAmount(createBet));

    // ⚠️ Sınırlar cüzdana göre; "10 – 100.000" SİTE birimiydi.
    if (!parsedBet || parsedBet < betLimits.min_bet)
      return toast.error(`Minimum bet is ${walletAmount(betLimits.min_bet, wallet)}.`);
    if (parsedBet > betLimits.max_bet)
      return toast.error(`Maximum bet is ${walletAmount(betLimits.max_bet, wallet)}.`);
    
    try {
      const res = await axios.post(`${BACKEND_URL}/api/game/coinflip/create`, { amount: parsedBet, side: createSide }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setIsCreateModalOpen(false); 
      toast.success("Coinflip created successfully!"); 
      
      const correctUsername = currentUser?.site_username || currentUser?.username || 'Unknown';
      
      openGameModal({ 
        id: res.data.game_id, 
        bet: parsedBet, 
        creator_id: currentUser?.id, 
        creator_username: correctUsername,
        creator_side: createSide, 
        status: 'waiting' 
      });
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Error creating game'); 
    }
  };

  const handleJoin = async (gameId, e) => {
    if(e) e.stopPropagation(); 
    try {
      await axios.post(`${BACKEND_URL}/api/game/coinflip/join`, { game_id: gameId }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Joined match successfully!"); 
      
      const correctUsername = currentUser?.site_username || currentUser?.username || 'Unknown';
      const baseGame = selectedGame?.id === gameId ? selectedGame : activeGames.find(g => g.id === gameId);
      
      if (baseGame) {
        openGameModal({
          ...baseGame,
          joiner_id: currentUser?.id || 'player',
          joiner_username: correctUsername,
          joiner_is_bot: false,
          status: 'starting'
        });
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Error joining game'); 
    }
  };

  const handleCallBot = async (gameId) => {
    try {
      await axios.post(`${BACKEND_URL}/api/game/coinflip/bot`, { game_id: gameId }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Bot called successfully!"); 
      
      if (selectedGame && selectedGame.id === gameId) {
        openGameModal({
          ...selectedGame,
          joiner_id: 'bot_optimistic',
          joiner_username: 'Bot',
          joiner_is_bot: true,
          status: 'starting'
        });
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Error calling bot'); 
    }
  };

  const openGameModal = (game) => {
    clearReplayTimers(); 
    setSelectedGame(game);
    
    if (game.status === 'finished') {
      setModalState('starting');
      setCountdown(2);
      
      const t1 = setTimeout(() => {
        setModalState('flipping');
        const t2 = setTimeout(() => {
          setModalState('finished');
        }, 5000);
        replayTimers.current.push(t2);
      }, 2000);
      replayTimers.current.push(t1);
    } else {
      setModalState(game.status);
    }
  };

  const closeModal = () => {
    clearReplayTimers(); 
    setSelectedGame(null);
    setModalState('waiting');
  };

  const getSideColor = (side) => side === 'heads' ? 'text-yellow-500 border-yellow-500/50 bg-yellow-500/10' : 'text-slate-400 border-slate-400/50 bg-slate-400/10';
  const getSideIcon = (side) => side === 'heads' ? 'H' : 'T';

  // ID'ler bazen sayı bazen string gelebildiği için güvenli karşılaştırma
  const sameId = (a, b) => a != null && b != null && String(a) === String(b);
  const getOppositeSide = (side) => (side === 'heads' ? 'tails' : 'heads');

  // Paranın yüzünü AYRI bir alandan değil, doğrudan kazanandan türetiyoruz.
  // Böylece gösterilen yüz ile kazanan oyuncu asla çelişemez.
  const getCoinSide = (game) => {
    if (!game) return 'heads';
    if (game.winner_id) {
      return sameId(game.winner_id, game.creator_id)
        ? game.creator_side
        : getOppositeSide(game.creator_side);
    }
    // Henüz kazanan yoksa (waiting/starting) eldeki bilgiyi göster
    return game.winning_side || game.creator_side;
  };

  const filteredActive = activeGames.filter(g => {
    if (filter === 'open') return g.status === 'waiting';
    if (filter === 'progress') return g.status !== 'waiting';
    return true;
  });

  return (
    <div className="min-h-screen bg-[#0E0F11] pt-20 md:pt-24 pb-12 relative">
      <div className={`max-w-[1800px] mx-auto px-2 md:px-4 flex gap-6 transition-[padding] duration-300 ${chatOpen ? 'md:pl-[340px] lg:pl-[370px]' : ''}`}>
          {/* 💬 Sohbet App.js'te TEK kopya render ediliyor (ChatDock).
              Sayfa-içi kopya kaldırıldı: her gezinmede WebSocket kopup
              yeniden bağlanıyor ve 4 HTTP isteği tekrar atılıyordu. */}
        <main className="flex-1 min-w-0">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-6 md:mb-8 gap-4 px-2 md:px-0">
            <div>
              <h1 className="font-heading font-black text-3xl md:text-4xl text-white uppercase tracking-wider flex items-center gap-2 md:gap-3">
                <Coins className="w-6 h-6 md:w-8 md:h-8 text-yellow-500" /> Coinflip
              </h1>
              <p className="text-xs md:text-sm text-zinc-400 mt-1 md:mt-2 font-medium">Double your money or lose it all. Choose your side!</p>
            </div>
            
            <button 
              onClick={() => setIsCreateModalOpen(true)} 
              className="px-6 md:px-8 py-3 md:py-3.5 bg-gradient-to-r from-[#15913f] to-[#16A34A] hover:from-[#16A34A] hover:to-[#2ecf6e] text-white rounded-xl font-black uppercase text-xs md:text-sm tracking-widest shadow-[0_0_20px_rgba(22,163,74,0.3)] flex items-center justify-center gap-2 transition-transform hover:scale-105"
            >
              <Plus className="w-4 h-4 md:w-5 md:h-5" /> Create Game
            </button>
          </div>

          <div className="flex items-center gap-2 p-1.5 bg-[#1A1D20] rounded-xl border border-[#2A2D31] w-fit mb-6 mx-2 md:mx-0">
            {['all', 'open', 'progress'].map(f => (
              <button 
                key={f} onClick={() => setFilter(f)}
                className={`px-3 md:px-4 py-1.5 md:py-2 rounded-lg text-[10px] md:text-xs font-bold uppercase tracking-widest transition-all ${filter === f ? 'bg-[#2A2D31] text-white shadow-md' : 'text-zinc-500 hover:text-zinc-300'}`}
              >
                {f}
              </button>
            ))}
          </div>

          {/* LOBİ (AKTİF OYUNLAR) */}
          <div className="space-y-3 md:space-y-4 mb-8 md:mb-12">
            {loading ? (
              <div className="py-12 flex justify-center"><Activity className="w-8 h-8 text-yellow-500 animate-spin" /></div>
            ) : filteredActive.length > 0 ? (
              <AnimatePresence initial={false}>
                {filteredActive.map(game => (
                  <motion.div 
                    initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, scale: 0.95 }}
                    key={game.id} 
                    onClick={() => openGameModal(game)} 
                    className={`w-full border rounded-xl md:rounded-2xl p-3 md:p-4 flex items-center justify-between cursor-pointer transition-all group ${game.status === 'finished' ? 'bg-[#1A1D20]/80 border-[#16A34A]/50' : 'bg-[#1A1D20] border-[#2A2D31] hover:border-yellow-500/50 hover:-translate-y-1 hover:shadow-lg'}`}
                  >
                    {/* Sol: Kuran Adam */}
                    <div className="flex items-center gap-2 md:gap-4 w-1/3">
                      <div className={`w-10 h-10 md:w-14 md:h-14 rounded-lg md:rounded-xl bg-[#15171a] border flex items-center justify-center overflow-hidden relative shrink-0 transition-all ${game.status === 'finished' && sameId(game.winner_id, game.creator_id) ? 'border-[#16A34A] drop-shadow-[0_0_15px_rgba(22,163,74,0.8)] z-10 scale-110' : 'border-[#2A2D31]'}`}>
                        <img 
                          src={`${BACKEND_URL}/api/user/avatar/${game.creator_username}`} 
                          alt="avatar" 
                          className="w-full h-full object-cover" 
                          onError={(e) => { e.target.onerror = null; e.target.src = "/default-avatar.png"; }}
                        />
                        <div className={`absolute bottom-0 right-0 w-3 h-3 md:w-4 md:h-4 flex items-center justify-center text-[8px] md:text-[10px] font-bold ${game.creator_side === 'heads' ? 'bg-yellow-500 text-black' : 'bg-slate-400 text-black'}`}>
                          {getSideIcon(game.creator_side)}
                        </div>
                      </div>
                      <div className="min-w-0">
                        <p className={`text-xs md:text-sm font-bold truncate transition-colors ${game.status === 'finished' && sameId(game.winner_id, game.creator_id) ? 'text-[#2ecf6e]' : 'text-white group-hover:text-yellow-400'}`}>{game.creator_username}</p>
                      </div>
                    </div>

                    {/* Orta: Tutar ve Aksiyon */}
                    <div className="flex flex-col items-center justify-center w-1/3 px-1">
                      <p className={`text-base md:text-2xl font-black mm-num mb-1 md:mb-2 text-center ${game.status === 'finished' ? 'text-zinc-500' : 'text-white'}`}>
                        {/* ⚠️ Coinflip TEK CÜZDANLIDIR (D4): tutar lobinin MÜHÜRLÜ cüzdanının
                            biriminde. Liste zaten aktif cüzdana göre filtreli gelir. */}
                        <WalletValue amount={game.bet} wallet={game.wallet} />
                      </p>
                      
                      {game.status === 'waiting' ? (
                         game.creator_id !== currentUser?.id ? (
                           <button onClick={(e) => handleJoin(game.id, e)} className="w-full max-w-[100px] md:max-w-[120px] px-2 md:px-6 py-1 md:py-1.5 bg-[#16A34A]/20 text-[#2ecf6e] hover:bg-[#16A34A] hover:text-white border border-[#16A34A]/50 rounded-lg text-[10px] md:text-xs font-bold uppercase tracking-widest transition-all">
                             Join
                           </button>
                         ) : (
                           <span className="w-full max-w-[100px] md:max-w-[120px] px-2 md:px-6 py-1 md:py-1.5 bg-[#2A2D31]/50 text-zinc-400 border border-[#2A2D31] rounded-lg text-[10px] md:text-xs font-bold uppercase tracking-widest transition-all text-center block">
                             Waiting
                           </span>
                         )
                      ) : (
                         <div className="flex flex-col items-center gap-1">
                           <span className={`text-[8px] md:text-[10px] font-black uppercase tracking-widest text-center ${game.status === 'finished' ? 'text-[#2ecf6e]' : 'text-yellow-400 animate-pulse'}`}>
                             {game.status === 'starting' ? 'Starting...' : (game.status === 'finished' ? 'Finished!' : 'Flipping...')}
                           </span>
                           <span className="text-[10px] md:text-xs font-bold text-[#c98bf0] flex items-center justify-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                             <Eye className="w-3 h-3 md:w-4 md:h-4" /> <span className="hidden md:inline">Click to View</span>
                           </span>
                         </div>
                      )}
                    </div>

                    {/* Sağ: Katılan veya Beklenen */}
                    <div className="flex items-center justify-end gap-2 md:gap-4 w-1/3">
                      {game.status === 'waiting' ? (
                         <>
                          <div className="text-right hidden md:block">
                            <p className="text-sm font-bold text-zinc-500 truncate">Waiting...</p>
                          </div>
                          <div className="w-10 h-10 md:w-14 md:h-14 rounded-lg md:rounded-xl bg-[#15171a] border-2 border-dashed border-[#2A2D31] flex items-center justify-center group-hover:border-[#16A34A]/50 transition-colors shrink-0">
                            <Users className="w-5 h-5 md:w-6 md:h-6 text-zinc-600 group-hover:text-[#16A34A]/50" />
                          </div>
                         </>
                      ) : (
                         <>
                          <div className="text-right hidden md:block min-w-0">
                            <p className={`text-xs md:text-sm font-bold truncate ${game.status === 'finished' && !sameId(game.winner_id, game.creator_id) ? 'text-[#2ecf6e]' : 'text-white'}`}>{game.joiner_username}</p>
                          </div>
                          <div className={`w-10 h-10 md:w-14 md:h-14 rounded-lg md:rounded-xl bg-[#15171a] border flex items-center justify-center overflow-hidden relative shrink-0 transition-all ${game.status === 'finished' && !sameId(game.winner_id, game.creator_id) ? 'border-[#16A34A] drop-shadow-[0_0_15px_rgba(22,163,74,0.8)] z-10 scale-110' : 'border-[#2A2D31]'}`}>
                            {game.joiner_is_bot ? <Bot className="w-6 h-6 md:w-8 md:h-8 text-[#c98bf0]" /> : (
                              <img 
                                src={`${BACKEND_URL}/api/user/avatar/${game.joiner_username}`} 
                                className="w-full h-full object-cover" 
                                alt="joiner" 
                                onError={(e) => { e.target.onerror = null; e.target.src = "/default-avatar.png"; }}
                              />
                            )}
                            <div className={`absolute bottom-0 left-0 w-3 h-3 md:w-4 md:h-4 flex items-center justify-center text-[8px] md:text-[10px] font-bold ${game.creator_side === 'heads' ? 'bg-slate-400 text-black' : 'bg-yellow-500 text-black'}`}>
                              {getSideIcon(game.creator_side === 'heads' ? 'tails' : 'heads')}
                            </div>
                          </div>
                         </>
                      )}
                    </div>
                  </motion.div>
                ))}
              </AnimatePresence>
            ) : (
              <div className="bg-[#1A1D20]/50 border border-[#2A2D31]/50 rounded-xl md:rounded-2xl py-8 md:py-12 flex flex-col items-center justify-center text-zinc-500 mx-2 md:mx-0">
                <Coins className="w-10 h-10 md:w-12 md:h-12 mb-2 md:mb-3 opacity-20" />
                <p className="text-xs md:text-sm font-bold uppercase tracking-widest text-center px-4">No active coinflips</p>
              </div>
            )}
          </div>

          {/* GEÇMİŞ OYUNLAR */}
          <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b border-[#2A2D31] pb-3 md:pb-4 px-2 md:px-0">
            <History className="w-4 h-4 md:w-5 md:h-5 text-zinc-400" />
            <h2 className="font-heading font-bold text-lg md:text-xl text-white uppercase tracking-wide">Latest Results</h2>
          </div>
          <div className="space-y-3 opacity-80 hover:opacity-100 transition-opacity pb-8">
            <AnimatePresence initial={false}>
              {finishedGames.map((game, idx) => {
                const isCreatorWinner = sameId(game.winner_id, game.creator_id);
                const shownSide = getCoinSide(game);
                
                return (
                  <motion.div 
                    initial={{ opacity: 0, y: -20, scale: 0.95 }} 
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    key={game.id} 
                    onClick={() => openGameModal(game)} 
                    className="w-full bg-[#1A1D20]/50 border border-[#2A2D31]/50 hover:border-[#16A34A]/50 hover:-translate-y-1 hover:shadow-lg rounded-xl md:rounded-2xl p-3 md:p-4 flex items-center justify-between cursor-pointer transition-all group relative overflow-hidden"
                    title="Click to Replay!"
                  >
                    <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center z-20 backdrop-blur-[1px]">
                      <div className="flex items-center gap-1.5 md:gap-2 bg-[#16A34A]/90 text-white px-3 md:px-4 py-1 md:py-1.5 rounded-full font-bold uppercase tracking-widest text-[10px] md:text-xs shadow-xl">
                         <Play className="w-2.5 h-2.5 md:w-3 md:h-3" /> <span className="hidden sm:inline">Replay</span>
                      </div>
                    </div>

                    <div className="flex items-center gap-2 md:gap-4 w-1/3">
                      <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg md:rounded-xl flex items-center justify-center overflow-hidden border-2 shrink-0 transition-all ${isCreatorWinner ? 'border-[#16A34A] drop-shadow-[0_0_10px_rgba(22,163,74,0.5)] z-10' : 'border-[#2A2D31] opacity-50'}`}>
                        <img 
                          src={`${BACKEND_URL}/api/user/avatar/${game.creator_username}`} 
                          alt="avatar" 
                          className="w-full h-full object-cover" 
                          onError={(e) => { e.target.onerror = null; e.target.src = "/default-avatar.png"; }}
                        />
                      </div>
                      <div className="min-w-0">
                         <p className={`text-xs md:text-sm font-bold truncate ${isCreatorWinner ? 'text-white' : 'text-zinc-500'}`}>{game.creator_username}</p>
                      </div>
                    </div>

                    <div className="flex flex-col items-center w-1/3 px-1">
                      <p className="text-base md:text-lg font-black text-zinc-400 mm-num text-center truncate w-full">
                         {/* ⚠️ Coinflip TEK CÜZDANLIDIR (D4): tutar lobinin MÜHÜRLÜ cüzdanının
                            biriminde. Liste zaten aktif cüzdana göre filtreli gelir. */}
                        <WalletValue amount={game.bet} wallet={game.wallet} />
                      </p>
                      <div className={`mt-0.5 md:mt-1 w-6 h-6 md:w-8 md:h-8 rounded-full flex items-center justify-center font-black text-[10px] md:text-xs shrink-0 ${getSideColor(shownSide)}`}>
                        {getSideIcon(shownSide)}
                      </div>
                    </div>

                    <div className="flex items-center justify-end gap-2 md:gap-4 w-1/3">
                      <div className="min-w-0 text-right">
                         <p className={`text-xs md:text-sm font-bold truncate ${!isCreatorWinner ? 'text-white' : 'text-zinc-500'}`}>{game.joiner_username}</p>
                      </div>
                      <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg md:rounded-xl flex items-center justify-center overflow-hidden border-2 shrink-0 transition-all ${!isCreatorWinner ? 'border-[#16A34A] drop-shadow-[0_0_10px_rgba(22,163,74,0.5)] z-10' : 'border-[#2A2D31] opacity-50'}`}>
                        {game.joiner_is_bot ? <Bot className={`w-6 h-6 md:w-8 md:h-8 ${!isCreatorWinner ? 'text-[#c98bf0]' : 'text-[#7b2fc4]'}`} /> : (
                          <img 
                            src={`${BACKEND_URL}/api/user/avatar/${game.joiner_username}`} 
                            className="w-full h-full object-cover" 
                            alt="joiner" 
                            onError={(e) => { e.target.onerror = null; e.target.src = "/default-avatar.png"; }}
                          />
                        )}
                      </div>
                    </div>
                  </motion.div>
                );
              })}
            </AnimatePresence>
          </div>
        </main>
      </div>

      {/* --- OYUN KURMA MODALI --- */}
      <AnimatePresence>
        {isCreateModalOpen && (
          <motion.div 
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 z-[60] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4"
          >
            <motion.div 
              initial={{ scale: 0.9, y: 20 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.9, y: 20 }}
              className="bg-[#15171a] border border-[#2A2D31] rounded-2xl md:rounded-3xl p-5 md:p-8 w-full max-w-md relative shadow-[0_0_50px_rgba(0,0,0,0.8)] flex flex-col"
            >
              <button onClick={() => setIsCreateModalOpen(false)} className="absolute top-3 right-3 md:top-4 md:right-4 text-zinc-500 hover:text-white bg-[#1A1D20] p-1.5 md:p-2 rounded-full transition-colors">
                <X className="w-5 h-5 md:w-5 md:h-5" />
              </button>

              <h2 className="text-xl md:text-2xl font-black text-white uppercase tracking-widest flex items-center gap-2 mb-4 md:mb-6">
                <Coins className="w-5 h-5 md:w-6 md:h-6 text-yellow-500" /> Create Coinflip
              </h2>

              <div className="space-y-4 md:space-y-6">
                <div>
                  <label className="text-[10px] md:text-xs font-bold text-zinc-400 uppercase tracking-widest mb-1.5 md:mb-2 block">Bet Amount</label>
                  <div className="flex bg-[#1A1D20] border border-[#2A2D31] rounded-xl overflow-hidden focus-within:border-yellow-500 transition-colors">
                    <div className="pl-3 md:pl-4 flex items-center justify-center shrink-0">
                      <span className="text-zinc-500 font-bold">$</span>
                    </div>
                    <input
                      type="text" 
                      value={createBet}
                      onChange={(e) => handleBetChange(e.target.value)}
                      className="w-full min-w-0 bg-transparent py-3 md:py-4 px-2 md:px-3 text-white font-bold outline-none uppercase text-sm md:text-base"
                      placeholder="10"
                    />
                    <div className="flex border-l border-[#2A2D31] shrink-0">
                      <button onClick={() => addBetAmount(10)} className="px-2 md:px-4 text-[10px] md:text-xs font-bold text-zinc-400 hover:text-white hover:bg-[#33363b] transition-colors border-r border-[#2A2D31]">+10</button>
                      <button onClick={() => multiplyBet(0.5)} className="px-2 md:px-4 text-[10px] md:text-xs font-bold text-zinc-400 hover:text-white hover:bg-[#33363b] transition-colors border-r border-[#2A2D31]">1/2</button>
                      <button onClick={() => multiplyBet(2)} className="px-2 md:px-4 text-[10px] md:text-xs font-bold text-zinc-400 hover:text-white hover:bg-[#33363b] transition-colors">2x</button>
                    </div>
                  </div>
                </div>

                <div>
                  <label className="text-[10px] md:text-xs font-bold text-zinc-400 uppercase tracking-widest mb-1.5 md:mb-2 block">Choose Your Side</label>
                  <div className="flex gap-2 md:gap-3">
                    <button 
                      onClick={() => setCreateSide('heads')}
                      className={`flex-1 py-3 md:py-4 rounded-xl border-2 font-black uppercase tracking-widest flex flex-col items-center justify-center gap-1.5 md:gap-2 transition-all ${createSide === 'heads' ? 'bg-yellow-500/20 border-yellow-500 text-yellow-400 shadow-[0_0_15px_rgba(234,179,8,0.3)]' : 'bg-[#1A1D20] border-[#2A2D31] text-zinc-500 hover:border-yellow-500/50'}`}
                    >
                      <div className="w-8 h-8 md:w-12 md:h-12 rounded-full bg-gradient-to-br from-yellow-400 via-yellow-500 to-yellow-700 flex items-center justify-center text-black border-2 border-yellow-300 shadow-inner">
                         <span className="text-sm md:text-xl">H</span>
                      </div>
                      <span className="text-[10px] md:text-xs">Heads</span>
                    </button>
                    <button 
                      onClick={() => setCreateSide('tails')}
                      className={`flex-1 py-3 md:py-4 rounded-xl border-2 font-black uppercase tracking-widest flex flex-col items-center justify-center gap-1.5 md:gap-2 transition-all ${createSide === 'tails' ? 'bg-slate-400/20 border-slate-400 text-slate-300 shadow-[0_0_15px_rgba(148,163,184,0.3)]' : 'bg-[#1A1D20] border-[#2A2D31] text-zinc-500 hover:border-slate-400/50'}`}
                    >
                      <div className="w-8 h-8 md:w-12 md:h-12 rounded-full bg-gradient-to-br from-slate-300 via-slate-400 to-slate-600 flex items-center justify-center text-black border-2 border-slate-200 shadow-inner">
                        <span className="text-sm md:text-xl">T</span>
                      </div>
                      <span className="text-[10px] md:text-xs">Tails</span>
                    </button>
                  </div>
                </div>

                <button 
                  onClick={handleCreateSubmit}
                  className="w-full py-3.5 md:py-4 bg-gradient-to-r from-[#15913f] to-[#16A34A] hover:from-[#16A34A] hover:to-[#2ecf6e] text-white rounded-xl font-black uppercase tracking-widest shadow-[0_0_20px_rgba(22,163,74,0.3)] transition-transform hover:scale-[1.02] mt-2 md:mt-4 text-sm md:text-base"
                >
                  Confirm & Create
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* --- OYUN İZLEME / OYNAMA MODALI --- */}
      <AnimatePresence>
        {selectedGame && !isCreateModalOpen && (
          <motion.div 
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 z-[60] flex items-center justify-center bg-black/90 backdrop-blur-sm p-2 md:p-4 overflow-y-auto"
          >
            <motion.div 
              initial={{ scale: 0.9, y: 30 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.9, y: 30 }}
              className="bg-[#15171a] border border-[#2A2D31] rounded-2xl md:rounded-3xl p-4 md:p-6 w-full max-w-4xl relative shadow-[0_0_80px_rgba(0,0,0,0.9)] flex flex-col my-auto"
            >
              <button onClick={closeModal} className="absolute top-3 right-3 md:top-4 md:right-4 text-zinc-500 hover:text-white bg-[#1A1D20] p-1.5 md:p-2 rounded-full transition-colors z-50">
                <X className="w-5 h-5 md:w-5 md:h-5" />
              </button>

              <div className="flex flex-col md:flex-row justify-between items-center gap-12 md:gap-0 mb-8 md:mb-12 px-2 md:px-8 pt-6 md:pt-4">
                
                {/* SOL: KURUCU */}
                <div className="flex flex-col items-center gap-2 md:gap-3 relative">
                  <div className={`absolute inset-0 bg-[#16A34A] rounded-full blur-2xl md:blur-3xl transition-opacity duration-500 ${modalState === 'finished' && sameId(selectedGame.winner_id, selectedGame.creator_id) ? 'opacity-40' : 'opacity-0'}`} />
                  <div className={`w-24 h-24 md:w-36 md:h-36 rounded-2xl bg-[#1A1D20] overflow-hidden border-4 md:border-[5px] relative z-10 transition-all duration-500 shrink-0 ${modalState === 'finished' && sameId(selectedGame.winner_id, selectedGame.creator_id) ? 'border-[#16A34A] scale-110 drop-shadow-[0_0_30px_rgba(22,163,74,0.8)]' : 'border-[#2A2D31]'}`}>
                     <img 
                       src={`${BACKEND_URL}/api/user/avatar/${selectedGame.creator_username}`} 
                       alt="avatar" 
                       className="w-full h-full object-cover" 
                       onError={(e) => { e.target.onerror = null; e.target.src = "/default-avatar.png"; }}
                     />
                  </div>
                  <p className="font-bold text-lg md:text-xl text-white mt-1 md:mt-2 relative z-10 text-center">{selectedGame.creator_username}</p>
                  <span className={`px-3 md:px-4 py-1 md:py-1.5 rounded-md md:rounded-lg text-[10px] md:text-xs font-black uppercase border relative z-10 ${getSideColor(selectedGame.creator_side)}`}>
                    {selectedGame.creator_side}
                  </span>
                </div>

                {/* ORTA: COIN ANİMASYONU */}
                <div className="flex flex-col items-center justify-center relative w-full md:w-64 my-4 md:my-0">
                  <Coin3D isFlipping={modalState === 'flipping'} resultSide={getCoinSide(selectedGame)} />
                  
                  <div className="absolute -bottom-16 md:-bottom-24 w-full md:w-72 text-center pointer-events-none">
                    {modalState === 'waiting' && <p className="text-zinc-400 font-bold animate-pulse text-sm md:text-lg">Waiting for opponent...</p>}
                    {modalState === 'starting' && <p className="text-yellow-400 font-black text-2xl md:text-3xl animate-bounce drop-shadow-lg">Flipping in {countdown}...</p>}
                    {modalState === 'finished' && (
                       <motion.p initial={{ scale: 0.5, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} className="text-[#2ecf6e] font-black text-xl md:text-3xl uppercase tracking-widest drop-shadow-[0_0_15px_rgba(22,163,74,0.6)]">
                         Winner: <br/><span className="text-white text-lg md:text-2xl">{sameId(selectedGame.winner_id, selectedGame.creator_id) ? selectedGame.creator_username : selectedGame.joiner_username}</span>
                       </motion.p>
                    )}
                  </div>
                </div>

                {/* SAĞ: KATILAN */}
                <div className="flex flex-col items-center gap-2 md:gap-3 relative mt-8 md:mt-0">
                  <div className={`absolute inset-0 bg-[#16A34A] rounded-full blur-2xl md:blur-3xl transition-opacity duration-500 ${modalState === 'finished' && !sameId(selectedGame.winner_id, selectedGame.creator_id) ? 'opacity-40' : 'opacity-0'}`} />
                  <div className={`w-24 h-24 md:w-36 md:h-36 rounded-2xl overflow-hidden border-4 md:border-[5px] flex items-center justify-center relative z-10 transition-all duration-500 shrink-0 ${selectedGame.joiner_id ? (modalState === 'finished' && !sameId(selectedGame.winner_id, selectedGame.creator_id) ? 'border-[#16A34A] bg-[#1A1D20] scale-110 drop-shadow-[0_0_30px_rgba(22,163,74,0.8)]' : 'border-[#2A2D31] bg-[#1A1D20]') : 'border-[#2A2D31] bg-[#15171a] border-dashed'}`}>
                    {selectedGame.joiner_id ? (
                      selectedGame.joiner_is_bot ? <Bot className="w-12 h-12 md:w-20 md:h-20 text-[#c98bf0]" /> : (
                        <img 
                          src={`${BACKEND_URL}/api/user/avatar/${selectedGame.joiner_username}`} 
                          className="w-full h-full object-cover" 
                          alt="joiner" 
                          onError={(e) => { e.target.onerror = null; e.target.src = "/default-avatar.png"; }}
                        />
                      )
                    ) : (
                      <Users className="w-8 h-8 md:w-12 md:h-12 text-zinc-600" />
                    )}
                  </div>
                  <p className="font-bold text-lg md:text-xl text-white mt-1 md:mt-2 relative z-10 text-center">{selectedGame.joiner_id ? selectedGame.joiner_username : 'Empty Seat'}</p>
                  {selectedGame.joiner_id && (
                    <span className={`px-3 md:px-4 py-1 md:py-1.5 rounded-md md:rounded-lg text-[10px] md:text-xs font-black uppercase border relative z-10 ${getSideColor(selectedGame.creator_side === 'heads' ? 'tails' : 'heads')}`}>
                      {selectedGame.creator_side === 'heads' ? 'tails' : 'heads'}
                    </span>
                  )}
                </div>
              </div>

              <div className="mt-12 md:mt-20 pt-6 md:pt-8 border-t border-[#2A2D31] flex flex-col md:flex-row items-center justify-between gap-4 md:gap-0">
                <div className="text-2xl md:text-4xl font-black mm-num text-white flex items-center gap-2 md:gap-3 drop-shadow-md">
                   Pot: <WalletValue amount={selectedGame.bet * 2} wallet={selectedGame.wallet} />
                </div>

                {modalState === 'waiting' && currentUser?.id === selectedGame.creator_id && (
                  <button onClick={() => handleCallBot(selectedGame.id)} className="w-full md:w-auto px-6 md:px-8 py-3.5 md:py-4 bg-[#B059E8]/10 hover:bg-[#B059E8]/20 text-[#c98bf0] border border-[#B059E8]/30 rounded-xl font-black uppercase tracking-widest transition-all flex items-center justify-center gap-2 text-sm md:text-lg">
                    <Bot className="w-5 h-5 md:w-6 md:h-6" /> Call Bot
                  </button>
                )}

                {modalState === 'waiting' && currentUser?.id !== selectedGame.creator_id && (
                  <button onClick={(e) => handleJoin(selectedGame.id, e)} className="w-full md:w-auto px-8 md:px-12 py-3.5 md:py-4 bg-gradient-to-r from-[#15913f] to-[#16A34A] hover:from-[#16A34A] hover:to-[#2ecf6e] text-white rounded-xl font-black uppercase tracking-widest shadow-[0_0_30px_rgba(22,163,74,0.4)] transition-transform hover:scale-105 text-sm md:text-lg">
                    Join Match
                  </button>
                )}
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};